export const ANALYTICS_EVENTS = {
  WIDGET_OPEN: 'widget_open',
  CHAT_OPEN: 'chat_open',
  MESSAGE_SENT: 'message_sent',
  TICKET_MODAL_OPEN: 'ticket_modal_open',
  TICKET_CREATED: 'ticket_created',
  TICKET_REMINDER_DISMISSED: 'ticket_reminder_dismissed',
  TICKET_CLOSED: 'ticket_closed',
  MESSAGE_FEEDBACK: 'message_feedback',
  MESSAGE_AUDIO_PLAYED: 'message_audio_played',
  SOURCE_CLICKED: 'source_clicked',
  CHAT_EXPORTED: 'chat_exported',
  AGENT_ACTION_DECIDED: 'agent_action_decided',
  VIEW_RESULT_CLICKED: 'view_result_clicked',
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
} as const

/** How the user produced the message: typed it, dictated it, or tapped a suggested question. */
export type MessageSource = 'typed' | 'voice' | 'default_question' | 'dynamic_question'
